import api from './api';
import types from './mutation-types';

export default {
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	getPopupCarSales_({ commit, state }) {
		const { searchParams, pagingInfo } = state;
		return api
			.getPopupCarSales({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					const { pagingInfo, resultList } = data.body;
					commit(types.CAR_SALE_LIST, data !== null && data !== undefined ? resultList : null);
					commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	chkPmcIdCampNo_({ commit }, param) {
		//신청할때 체크함
		//console.log('파람', param);
		return api
			.chkPmcIdCampNo(param)
			.then(data => {
				if (data.header.code === 0) {
					/*
					commit(types.DEFAULT_ASSIGN, {
						key: 'chkPmcIdCampNoList',
						value: data?.body.result.cmpnNmList || []
					});
					*/
					//data = data.body.result.cmpnNmList
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
